import React, { useEffect, useState } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'moment/locale/fr'; // Import locale française
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import CustomToolbar from './CustomToolBar'; // chemin relatif selon ton arborescence

moment.locale('fr'); // Définit la locale à français
const localizer = momentLocalizer(moment);

const messages = {
  allDay: 'Toute la journée',
  previous: 'Précédent',
  next: 'Suivant',
  today: "Aujourd'hui",
  month: 'Mois',
  week: 'Semaine',
  day: 'Jour',
  agenda: 'Agenda',
  date: 'Date',
  time: 'Heure',
  event: 'Événement',
  showMore: total => `+ ${total} de plus`,
};

export default function BookingCalendar({ musicianId }) {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [currentView, setCurrentView] = useState('month');

  useEffect(() => {
    if (!musicianId) return;

    const fetchBookings = async () => {
      try {
        const q = query(collection(db, 'bookings'), where('entityId', '==', musicianId));
        const snapshot = await getDocs(q);

        const eventsData = snapshot.docs.map(doc => {
          const data = doc.data();
          const dateStr = data.date;
          const [day, month, year] = dateStr.split('/');
          const parsedDate = new Date(`${year}-${month}-${day}T00:00:00`);

          return {
            id: doc.id,
            title: data.status === 'Option' ? 'Option' : 'Réservé',
            start: parsedDate,
            end: parsedDate,
            allDay: true,
            location: data.location || 'Non renseignée',
            infoMessage: data.infoMessage || 'Aucune information supplémentaire',
            status: data.status || 'Réservé',
          };
        });

        setEvents(eventsData);
        setLoading(false);
      } catch (error) {
        console.error("Erreur chargement des réservations :", error);
        setLoading(false);
      }
    };

    fetchBookings();
  }, [musicianId]);

  if (loading) return <p style={{ color: 'white', textAlign: 'center' }}>Chargement du calendrier...</p>;

  return (
    <div style={{ height: 600, width: '100%' }}>
      <Calendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        date={currentDate}
        view={currentView}
        onNavigate={setCurrentDate}
        onView={setCurrentView}
        views={['month']}
        components={{
          toolbar: CustomToolbar,
        }}
        messages={messages}
        style={{
          backgroundColor: '#fff',
          color: '#000',
          borderRadius: 12,
          padding: 16,
          fontFamily: "'Orbitron', sans-serif",
          boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
        }}
        eventPropGetter={event => {
          let backgroundColor = '#ff9800'; // orange par défaut
          if (event.status === 'Réservé') {
            backgroundColor = '#4caf50'; // vert
          } else if (event.status === 'Option') {
            backgroundColor = '#2196f3'; // bleu
          }
          return {
            style: {
              backgroundColor,
              borderRadius: '8px',
              border: 'none',
              color: '#fff',
              fontWeight: '600',
              padding: '2px 6px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
              textAlign: 'center',
            },
          };
        }}
        popup
        onSelectEvent={event => {
          const message =
            `Réservation le ${moment(event.start).format('LL')}\n\n` +
            `Statut : ${event.status}\n\n` +
            `Localisation : ${event.location}\n\n` +
            `Info : ${event.infoMessage}\n\n` +
            `Cliquez sur OK pour fermer ce message.`;
          window.alert(message);
        }}
        dayPropGetter={() => ({
          style: {
            border: '1px solid #e0e0e0',
          },
        })}
      />
    </div>
  );
}
